import React, {createContext, useReducer} from "react";

let ConfirmContext = createContext();

let initialState = {
  visible: false,
  showLoadingOnSubmit: false,
  message: "Confirm?",
  submitLabel: "Yes",
  cancelLabel: "No",
  submitCallback: () => {},
  cancelCallback: () => {},
  actions: null,
};

let reducer = (state, action) => {
  switch (action.type) {
    case "reset":
      return initialState;
    case "show":
      return {...state, visible: true};
    case "hide":
      return {...state, visible: false};
    case "showConfirm":
      return {...state, visible: true, ...action.payload};
    default:
      return state;
  }
};

function ConfirmContextProvider(props) {
  let [confirm, confirmDispatch] = useReducer(reducer, initialState);
  let value = {confirm, confirmDispatch};

  return <ConfirmContext.Provider value={value}>{props.children}</ConfirmContext.Provider>;
}

let ConfirmContextConsumer = ConfirmContext.Consumer;

export {ConfirmContext, ConfirmContextProvider, ConfirmContextConsumer};
